import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: any; output: any; }
  CustomData: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: any; output: any; }
  IntType: { input: any; output: any; }
  ItemId: { input: any; output: any; }
  JsonField: { input: any; output: any; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum ColorBucketType {
  Black = 'black',
  Blue = 'blue',
  Brown = 'brown',
  Cyan = 'cyan',
  Green = 'green',
  Grey = 'grey',
  Orange = 'orange',
  Pink = 'pink',
  Purple = 'purple',
  Red = 'red',
  White = 'white',
  Yellow = 'yellow'
}

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaqCategoryModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqCategoryModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqCategoryModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum FaqCategoryModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

export enum FaviconType {
  AppleTouchIcon = 'appleTouchIcon',
  Icon = 'icon',
  MsApplication = 'msApplication'
}

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  Compress = 'compress',
  Enhance = 'enhance',
  Format = 'format',
  Redeye = 'redeye'
}

export enum ImgixParamsBgRemoveFgType {
  Auto = 'auto',
  Car = 'car'
}

export enum ImgixParamsBlendAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendCrop {
  Bottom = 'bottom',
  Faces = 'faces',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsBlendFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsBlendMode {
  Burn = 'burn',
  Color = 'color',
  Darken = 'darken',
  Difference = 'difference',
  Dodge = 'dodge',
  Exclusion = 'exclusion',
  Hardlight = 'hardlight',
  Hue = 'hue',
  Lighten = 'lighten',
  Luminosity = 'luminosity',
  Multiply = 'multiply',
  Normal = 'normal',
  Overlay = 'overlay',
  Saturation = 'saturation',
  Screen = 'screen',
  Softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  Inherit = 'inherit'
}

export enum ImgixParamsCh {
  Dpr = 'dpr',
  SaveData = 'saveData',
  Width = 'width'
}

export enum ImgixParamsCrop {
  Bottom = 'bottom',
  Edges = 'edges',
  Entropy = 'entropy',
  Faces = 'faces',
  Focalpoint = 'focalpoint',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsCs {
  Adobergb1998 = 'adobergb1998',
  Origin = 'origin',
  Srgb = 'srgb',
  Strip = 'strip',
  Tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  Blur = 'blur',
  Gen = 'gen',
  Generative = 'generative',
  Gradient = 'gradient',
  Solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientCs {
  Hsl = 'hsl',
  Lch = 'lch',
  Linear = 'linear',
  Oklab = 'oklab',
  Srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsFillGradientType {
  Linear = 'linear',
  Radial = 'radial'
}

export enum ImgixParamsFit {
  Clamp = 'clamp',
  Clip = 'clip',
  Crop = 'crop',
  Facearea = 'facearea',
  Fill = 'fill',
  Fillmax = 'fillmax',
  Max = 'max',
  Min = 'min',
  Scale = 'scale'
}

export enum ImgixParamsFlip {
  H = 'h',
  Hv = 'hv',
  V = 'v'
}

export enum ImgixParamsFm {
  Avif = 'avif',
  Blurhash = 'blurhash',
  Gif = 'gif',
  Jp2 = 'jp2',
  Jpg = 'jpg',
  Json = 'json',
  Jxr = 'jxr',
  Mp4 = 'mp4',
  Pjpg = 'pjpg',
  Png = 'png',
  Png8 = 'png8',
  Png32 = 'png32',
  Webm = 'webm',
  Webp = 'webp'
}

export enum ImgixParamsIptc {
  Allow = 'allow',
  Block = 'block'
}

export enum ImgixParamsMarkAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsMarkFit {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
  Max = 'max',
  Scale = 'scale'
}

export enum ImgixParamsMarkTile {
  Grid = 'grid'
}

export enum ImgixParamsPalette {
  Css = 'css',
  Json = 'json'
}

export enum ImgixParamsRotType {
  Pivot = 'pivot',
  Straighten = 'straighten'
}

export enum ImgixParamsTransparency {
  Grid = 'grid'
}

export enum ImgixParamsTrim {
  Alpha = 'alpha',
  Auto = 'auto',
  Color = 'color'
}

export enum ImgixParamsTxtAlign {
  Bottom = 'bottom',
  Center = 'center',
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
  Top = 'top'
}

export enum ImgixParamsTxtClip {
  Ellipsis = 'ellipsis',
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export enum ImgixParamsTxtFit {
  Max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated'
}

export type JobPostingModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<JobPostingModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JobPostingModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  area?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum JobPostingModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Area_ASC = 'area_ASC',
  Area_DESC = 'area_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

export enum MuxThumbnailFormatType {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png'
}

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  pageLayout?: InputMaybe<StringFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  title?: InputMaybe<StringFilter>;
};

export enum PageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  PageLayout_ASC = 'pageLayout_ASC',
  PageLayout_DESC = 'pageLayout_DESC',
  Position_ASC = 'position_ASC',
  Position_DESC = 'position_DESC',
  Title_ASC = 'title_ASC',
  Title_DESC = 'title_DESC'
}

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  Icon = 'icon',
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export enum SiteLocale {
  De = 'de',
  Fr = 'fr'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  path?: InputMaybe<UploadPathFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  Basename_ASC = 'basename_ASC',
  Basename_DESC = 'basename_DESC',
  Filename_ASC = 'filename_ASC',
  Filename_DESC = 'filename_DESC',
  Format_ASC = 'format_ASC',
  Format_DESC = 'format_DESC',
  Id_ASC = 'id_ASC',
  Id_DESC = 'id_DESC',
  MimeType_ASC = 'mimeType_ASC',
  MimeType_DESC = 'mimeType_DESC',
  Resolution_ASC = 'resolution_ASC',
  Resolution_DESC = 'resolution_DESC',
  Size_ASC = 'size_ASC',
  Size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square'
}

/** Specifies how to filter by path */
export type UploadPathFilter = {
  /** Search the asset with the specified path */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified paths */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified path */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified paths */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  Archive = 'archive',
  Audio = 'audio',
  Image = 'image',
  Pdfdocument = 'pdfdocument',
  Presentation = 'presentation',
  Richtext = 'richtext',
  Spreadsheet = 'spreadsheet',
  Video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

export enum VideoMp4Res {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export type FaqCategoryFragment = { __typename: 'FaqCategoryRecord', id: any, title?: string | null, content?: { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | null };

type HeaderModulesPage_HeaderContactRecord_Fragment = { __typename: 'HeaderContactRecord', id: any, title?: string | null, contactCard?: { __typename: 'ContactCardRecord', id: any, nowOpenText?: string | null, closedText?: string | null, openingTimesText?: { value: any } | null, additionalText?: { value: any } | null } | null };

type HeaderModulesPage_HeaderDefaultRecord_Fragment = { __typename: 'HeaderDefaultRecord', id: any, title?: string | null, text?: { value: any } | null };

type HeaderModulesPage_HeaderMediumRecord_Fragment = { __typename: 'HeaderMediumRecord', id: any, title?: string | null, scrollText?: string | null, text?: { value: any } | null, asset?: { mimeType: string, imageLandscape?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, imagePortrait?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, mp4Url?: string | null, duration?: number | null, framerate?: number | null } | null } | null };

export type HeaderModulesPageFragment = HeaderModulesPage_HeaderContactRecord_Fragment | HeaderModulesPage_HeaderDefaultRecord_Fragment | HeaderModulesPage_HeaderMediumRecord_Fragment;

export type HeaderMediaFragment = { __typename: 'HeaderMediumRecord', id: any, title?: string | null, scrollText?: string | null, text?: { value: any } | null, asset?: { mimeType: string, imageLandscape?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, imagePortrait?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, mp4Url?: string | null, duration?: number | null, framerate?: number | null } | null } | null };

export type HeaderContactFragment = { __typename: 'HeaderContactRecord', id: any, title?: string | null, contactCard?: { __typename: 'ContactCardRecord', id: any, nowOpenText?: string | null, closedText?: string | null, openingTimesText?: { value: any } | null, additionalText?: { value: any } | null } | null };

export type HeaderDefaultFragment = { __typename: 'HeaderDefaultRecord', id: any, title?: string | null, text?: { value: any } | null };

export type JobPostingFragment = { __typename: 'JobPostingRecord', id: any, title?: string | null, area?: string | null, slug?: string | null, content: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> };

type JobPostingContent_ContentAccordionRecord_Fragment = { __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> };

type JobPostingContent_ContentMediumRecord_Fragment = { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null };

type JobPostingContent_ContentTextRecord_Fragment = { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null };

export type JobPostingContentFragment = JobPostingContent_ContentAccordionRecord_Fragment | JobPostingContent_ContentMediumRecord_Fragment | JobPostingContent_ContentTextRecord_Fragment;

export type PageLinkFragment = { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null };

export type NavigationLinkFragment = { id: any, linkText?: string | null, link?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null };

type Modules_ContentAccordionRecord_Fragment = { __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> };

type Modules_ContentClinic3dRecord_Fragment = { __typename: 'ContentClinic3dRecord', id: any, title?: string | null };

type Modules_ContentDownloadlistRecord_Fragment = { __typename: 'ContentDownloadlistRecord', id: any, downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> };

type Modules_ContentFaqRecord_Fragment = { __typename: 'ContentFaqRecord', id: any, faqItems: Array<{ id: any, question?: string | null, answer?: { value: any } | null, asset?: { url: string, alt?: string | null, mimeType: string, size: any, filename: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, category?: { __typename: 'FaqCategoryRecord', id: any, title?: string | null, content?: { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | null } | null }> };

type Modules_ContentIntro3dRecord_Fragment = { __typename: 'ContentIntro3dRecord', id: any };

type Modules_ContentJobslistRecord_Fragment = { __typename: 'ContentJobslistRecord', id: any, list: Array<{ __typename: 'JobPostingRecord', id: any, title?: string | null, area?: string | null, slug?: string | null, content: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> }> };

type Modules_ContentMediumRecord_Fragment = { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null };

type Modules_ContentStackedcardRecord_Fragment = { __typename: 'ContentStackedcardRecord', id: any, cardContent: Array<{ __typename: 'StackedCardItemRecord', id: any, text?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> };

type Modules_ContentTextRecord_Fragment = { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null };

type Modules_ContentValueRecord_Fragment = { __typename: 'ContentValueRecord', id: any, eyebrow?: string | null, title?: string | null, text?: { value: any } | null, values: Array<{ id: any, title?: string | null, description?: { value: any } | null, icon?: { id: any, alt?: string | null, url: string } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

type Modules_ContentVideoRecord_Fragment = { __typename: 'ContentVideoRecord', id: any, autoplay: any, muted: any, loop: any, asset?: { mimeType: string, imageLandscape?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, imagePortrait?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

type Modules_TeaserBigRecord_Fragment = { __typename: 'TeaserBigRecord', id: any, title?: string | null, textString?: string | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ModulesFragment = Modules_ContentAccordionRecord_Fragment | Modules_ContentClinic3dRecord_Fragment | Modules_ContentDownloadlistRecord_Fragment | Modules_ContentFaqRecord_Fragment | Modules_ContentIntro3dRecord_Fragment | Modules_ContentJobslistRecord_Fragment | Modules_ContentMediumRecord_Fragment | Modules_ContentStackedcardRecord_Fragment | Modules_ContentTextRecord_Fragment | Modules_ContentValueRecord_Fragment | Modules_ContentVideoRecord_Fragment | Modules_TeaserBigRecord_Fragment;

export type ContentAccordionFragment = { title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> };

export type ContentClinic3dFragment = { title?: string | null };

export type ContentDownloadlistFragment = { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> };

export type ContentFaqFragment = { faqItems: Array<{ id: any, question?: string | null, answer?: { value: any } | null, asset?: { url: string, alt?: string | null, mimeType: string, size: any, filename: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, category?: { __typename: 'FaqCategoryRecord', id: any, title?: string | null, content?: { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | null } | null }> };

export type ContentJobslistFragment = { list: Array<{ __typename: 'JobPostingRecord', id: any, title?: string | null, area?: string | null, slug?: string | null, content: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> }> };

export type ContentMediaFragment = { title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null };

export type ContentStackedCardFragment = { cardContent: Array<{ __typename: 'StackedCardItemRecord', id: any, text?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> };

export type ContentTextFragment = { title?: string | null, content?: { value: any } | null };

export type ContentValuesFragment = { eyebrow?: string | null, title?: string | null, text?: { value: any } | null, values: Array<{ id: any, title?: string | null, description?: { value: any } | null, icon?: { id: any, alt?: string | null, url: string } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> };

export type TeaserBigFragment = { title?: string | null, textString?: string | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ContentVideoFragment = { autoplay: any, muted: any, loop: any, asset?: { mimeType: string, imageLandscape?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, imagePortrait?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type PageMetaFragment = { id: any, slug?: string | null, title?: string | null, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> };

export type BackgroundVideoFragment = { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null };

export type ContactCardFragment = { __typename: 'ContactCardRecord', id: any, nowOpenText?: string | null, closedText?: string | null, openingTimesText?: { value: any } | null, additionalText?: { value: any } | null };

export type DownloadItemFragment = { id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null };

export type ImageFragment = { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type LinkFragment = { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null };

export type QuestionAndAnswerFragment = { id: any, question?: string | null, answer?: { value: any } | null, asset?: { url: string, alt?: string | null, mimeType: string, size: any, filename: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, category?: { __typename: 'FaqCategoryRecord', id: any, title?: string | null, content?: { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | null } | null };

export type StackedCardItemFragment = { __typename: 'StackedCardItemRecord', id: any, text?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null };

export type ValueFragment = { id: any, title?: string | null, description?: { value: any } | null, icon?: { id: any, alt?: string | null, url: string } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type ResponsiveImageFragment = { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string };

export type SiteInfoFragment = { pageTitle?: string | null, telephone?: string | null, email?: string | null, linkLocation?: string | null, copyrightInformation?: string | null, address?: { value: any } | null };

export type GetAllFaqCategoriesQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetAllFaqCategoriesQuery = { allFaqCategories: Array<{ title?: string | null, id: any, content?: { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | null }> };

export type GetClinicExperienceQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetClinicExperienceQuery = { clinicExperience?: { contentScenes: Array<{ title?: string | null, id: any, copy?: string | null, video?: { video?: { streamingUrl: string, thumbnailUrl: string, muxPlaybackId: string, title?: string | null, width: any, height: any, blurUpThumb?: string | null } | null, responsiveImage?: { src: string } | null } | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | null };

export type ContentSceneFragment = { title?: string | null, id: any, copy?: string | null, video?: { video?: { streamingUrl: string, thumbnailUrl: string, muxPlaybackId: string, title?: string | null, width: any, height: any, blurUpThumb?: string | null } | null, responsiveImage?: { src: string } | null } | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null };

export type GetFooterNavigationQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetFooterNavigationQuery = { footerNavigation?: { navLinks: Array<{ id: any, linkText?: string | null, link?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null }> } | null };

export type GetJobBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetJobBySlugQuery = { jobPosting?: { title?: string | null, content: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> } | null };

export type GetMainNavigationQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetMainNavigationQuery = { mainNavigation?: { navigationTeaser?: { image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { streamingUrl: string, muxPlaybackId: string } | null } | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null } | null, navLinks: Array<{ id: any, linkText?: string | null, link?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null }> } | null };

export type NavigationTeaserFragment = { image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { streamingUrl: string, muxPlaybackId: string } | null } | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null };

export type GetPageBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetPageBySlugQuery = { page?: { pageLayout?: string | null, id: any, slug?: string | null, title?: string | null, headerModule?: { __typename: 'HeaderContactRecord', id: any, title?: string | null, contactCard?: { __typename: 'ContactCardRecord', id: any, nowOpenText?: string | null, closedText?: string | null, openingTimesText?: { value: any } | null, additionalText?: { value: any } | null } | null } | { __typename: 'HeaderDefaultRecord', id: any, title?: string | null, text?: { value: any } | null } | { __typename: 'HeaderMediumRecord', id: any, title?: string | null, scrollText?: string | null, text?: { value: any } | null, asset?: { mimeType: string, imageLandscape?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, imagePortrait?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, mp4Url?: string | null, duration?: number | null, framerate?: number | null } | null } | null } | null, modules: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentClinic3dRecord', id: any, title?: string | null } | { __typename: 'ContentDownloadlistRecord', id: any, downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | { __typename: 'ContentFaqRecord', id: any, faqItems: Array<{ id: any, question?: string | null, answer?: { value: any } | null, asset?: { url: string, alt?: string | null, mimeType: string, size: any, filename: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, category?: { __typename: 'FaqCategoryRecord', id: any, title?: string | null, content?: { downloadList: Array<{ id: any, title?: string | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, document?: { __typename: 'FileField', size: any, filename: string, url: string } | null }> } | null } | null }> } | { __typename: 'ContentIntro3dRecord', id: any } | { __typename: 'ContentJobslistRecord', id: any, list: Array<{ __typename: 'JobPostingRecord', id: any, title?: string | null, area?: string | null, slug?: string | null, content: Array<{ __typename: 'ContentAccordionRecord', id: any, title?: string | null, showMultiple: any, accordionItems: Array<{ id: any, title?: string | null, content?: { value: any } | null }> } | { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null }> }> } | { __typename: 'ContentMediumRecord', id: any, title?: string | null, content?: { asset?: { url: string, mimeType: string, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null } | { asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | null } | { __typename: 'ContentStackedcardRecord', id: any, cardContent: Array<{ __typename: 'StackedCardItemRecord', id: any, text?: string | null, asset?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null }> } | { __typename: 'ContentTextRecord', id: any, title?: string | null, content?: { value: any } | null } | { __typename: 'ContentValueRecord', id: any, eyebrow?: string | null, title?: string | null, text?: { value: any } | null, values: Array<{ id: any, title?: string | null, description?: { value: any } | null, icon?: { id: any, alt?: string | null, url: string } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }> } | { __typename: 'ContentVideoRecord', id: any, autoplay: any, muted: any, loop: any, asset?: { mimeType: string, imageLandscape?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, imagePortrait?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null, video?: { muxPlaybackId: string, streamingUrl: string, duration?: number | null, framerate?: number | null } | null } | null, thumbnail?: { responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null } | { __typename: 'TeaserBigRecord', id: any, title?: string | null, textString?: string | null, link?: { __typename: 'LinkRecord', emailUrl?: string | null, externalUrl?: string | null, id: any, linkText?: string | null, linkType?: string | null, openLinkInNewWindow: any, internalUrl?: { __typename: 'PageRecord', id: any, title?: string | null, slug?: string | null, _allSlugLocales?: Array<{ value?: string | null, locale?: SiteLocale | null }> | null } | null } | null, image?: { url: string, alt?: string | null, mimeType: string, responsiveImage?: { src: string, width: any, height: any, alt?: string | null, title?: string | null, base64?: string | null, bgColor?: string | null, sizes: string } | null } | null }>, _seoMetaTags: Array<{ attributes?: any | null, content?: string | null, tag: string }> } | null };

export type GetSiteInfoQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetSiteInfoQuery = { siteInfo?: { pageTitle?: string | null, telephone?: string | null, email?: string | null, linkLocation?: string | null, copyrightInformation?: string | null, address?: { value: any } | null } | null };

export type GetTranslatedSlugsQueryVariables = Exact<{
  locale?: InputMaybe<SiteLocale>;
}>;


export type GetTranslatedSlugsQuery = { allPages: Array<{ slug?: string | null, title?: string | null, _allSlugLocales?: Array<{ locale?: SiteLocale | null, value?: string | null }> | null }> };

export const ResponsiveImageFragmentDoc = gql`
    fragment ResponsiveImage on ResponsiveImage {
  src
  width
  height
  alt
  title
  base64
  bgColor
  sizes
}
    `;
export const HeaderMediaFragmentDoc = gql`
    fragment HeaderMedia on HeaderMediumRecord {
  id
  __typename
  title
  text {
    value
  }
  asset {
    mimeType
    imageLandscape: responsiveImage(imgixParams: {fit: crop, w: 1500, auto: format}) {
      ...ResponsiveImage
    }
    imagePortrait: responsiveImage(imgixParams: {fit: crop, w: 400, auto: format}) {
      ...ResponsiveImage
    }
    video {
      muxPlaybackId
      streamingUrl
      mp4Url
      duration
      framerate
    }
  }
  scrollText
}
    `;
export const ContactCardFragmentDoc = gql`
    fragment ContactCard on ContactCardRecord {
  id
  __typename
  nowOpenText
  closedText
  openingTimesText {
    value
  }
  additionalText {
    value
  }
}
    `;
export const HeaderContactFragmentDoc = gql`
    fragment HeaderContact on HeaderContactRecord {
  id
  __typename
  title
  contactCard {
    ...ContactCard
  }
}
    `;
export const HeaderDefaultFragmentDoc = gql`
    fragment HeaderDefault on HeaderDefaultRecord {
  id
  __typename
  title
  text {
    value
  }
}
    `;
export const HeaderModulesPageFragmentDoc = gql`
    fragment HeaderModulesPage on PageModelHeaderModuleField {
  ...HeaderMedia
  ...HeaderContact
  ...HeaderDefault
}
    `;
export const PageLinkFragmentDoc = gql`
    fragment PageLink on PageRecord {
  __typename
  id
  title
  slug
  _allSlugLocales {
    value
    locale
  }
}
    `;
export const NavigationLinkFragmentDoc = gql`
    fragment NavigationLink on NavigationLinkRecord {
  id
  link {
    ...PageLink
  }
  linkText
}
    `;
export const ContentAccordionFragmentDoc = gql`
    fragment ContentAccordion on ContentAccordionRecord {
  accordionItems {
    id
    content {
      value
    }
    title
  }
  title
  showMultiple
}
    `;
export const ContentClinic3dFragmentDoc = gql`
    fragment ContentClinic3d on ContentClinic3dRecord {
  title
}
    `;
export const DownloadItemFragmentDoc = gql`
    fragment DownloadItem on DownloadItemRecord {
  id
  title
  thumbnail {
    responsiveImage(imgixParams: {auto: format, fit: crop, w: 100, ar: "2:3"}) {
      ...ResponsiveImage
    }
  }
  document {
    __typename
    size
    filename
    url
  }
}
    `;
export const ContentDownloadlistFragmentDoc = gql`
    fragment ContentDownloadlist on ContentDownloadlistRecord {
  downloadList: content {
    ...DownloadItem
  }
}
    `;
export const FaqCategoryFragmentDoc = gql`
    fragment FaqCategory on FaqCategoryRecord {
  __typename
  id
  title
  content {
    ...ContentDownloadlist
  }
}
    `;
export const QuestionAndAnswerFragmentDoc = gql`
    fragment QuestionAndAnswer on QuestionAndAnswerRecord {
  id
  question
  answer {
    value
  }
  asset {
    url
    alt
    mimeType
    size
    filename
    responsiveImage {
      ...ResponsiveImage
    }
    video {
      muxPlaybackId
      streamingUrl
      duration
      framerate
    }
  }
  category {
    ...FaqCategory
  }
}
    `;
export const ContentFaqFragmentDoc = gql`
    fragment ContentFaq on ContentFaqRecord {
  faqItems {
    ...QuestionAndAnswer
  }
}
    `;
export const ContentTextFragmentDoc = gql`
    fragment ContentText on ContentTextRecord {
  title
  content {
    value
  }
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on ImageRecord {
  asset {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
}
    `;
export const BackgroundVideoFragmentDoc = gql`
    fragment BackgroundVideo on BackgroundVideoRecord {
  asset {
    url
    mimeType
    video {
      muxPlaybackId
      streamingUrl
      duration
      framerate
    }
  }
}
    `;
export const ContentMediaFragmentDoc = gql`
    fragment ContentMedia on ContentMediumRecord {
  title
  content {
    ...Image
    ...BackgroundVideo
  }
}
    `;
export const JobPostingContentFragmentDoc = gql`
    fragment JobPostingContent on JobPostingModelContentField {
  ... on ContentAccordionRecord {
    id
    __typename
    ...ContentAccordion
  }
  ... on ContentTextRecord {
    id
    __typename
    ...ContentText
  }
  ... on ContentMediumRecord {
    id
    __typename
    ...ContentMedia
  }
}
    `;
export const JobPostingFragmentDoc = gql`
    fragment JobPosting on JobPostingRecord {
  __typename
  id
  title
  area
  slug
  content {
    ...JobPostingContent
  }
}
    `;
export const ContentJobslistFragmentDoc = gql`
    fragment ContentJobslist on ContentJobslistRecord {
  list {
    ...JobPosting
  }
}
    `;
export const LinkFragmentDoc = gql`
    fragment Link on LinkRecord {
  __typename
  emailUrl
  externalUrl
  id
  internalUrl {
    __typename
    ...PageLink
  }
  linkText
  linkType
  openLinkInNewWindow
}
    `;
export const StackedCardItemFragmentDoc = gql`
    fragment StackedCardItem on StackedCardItemRecord {
  id
  __typename
  asset {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
  text
  link {
    ...Link
  }
}
    `;
export const ContentStackedCardFragmentDoc = gql`
    fragment ContentStackedCard on ContentStackedcardRecord {
  cardContent: content {
    ...StackedCardItem
  }
}
    `;
export const ValueFragmentDoc = gql`
    fragment Value on ValueRecord {
  id
  title
  description {
    value
  }
  icon {
    id
    alt
    url
  }
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
}
    `;
export const ContentValuesFragmentDoc = gql`
    fragment ContentValues on ContentValueRecord {
  eyebrow
  title
  text {
    value
  }
  values {
    ...Value
  }
}
    `;
export const TeaserBigFragmentDoc = gql`
    fragment TeaserBig on TeaserBigRecord {
  title
  textString: text
  link {
    ...Link
  }
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
  }
}
    `;
export const ContentVideoFragmentDoc = gql`
    fragment ContentVideo on ContentVideoRecord {
  asset {
    mimeType
    imageLandscape: responsiveImage(imgixParams: {fit: crop, w: 1500, auto: format}) {
      ...ResponsiveImage
    }
    imagePortrait: responsiveImage(imgixParams: {fit: crop, w: 400, auto: format}) {
      ...ResponsiveImage
    }
    video {
      muxPlaybackId
      streamingUrl
      duration
      framerate
    }
  }
  autoplay
  muted
  loop
  thumbnail {
    responsiveImage(imgixParams: {fit: crop, w: 1200, auto: format}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const ModulesFragmentDoc = gql`
    fragment Modules on PageModelModulesField {
  ... on ContentAccordionRecord {
    id
    __typename
    ...ContentAccordion
  }
  ... on ContentClinic3dRecord {
    id
    __typename
    ...ContentClinic3d
  }
  ... on ContentDownloadlistRecord {
    id
    __typename
    ...ContentDownloadlist
  }
  ... on ContentFaqRecord {
    id
    __typename
    ...ContentFaq
  }
  ... on ContentIntro3dRecord {
    id
    __typename
  }
  ... on ContentJobslistRecord {
    id
    __typename
    ...ContentJobslist
  }
  ... on ContentMediumRecord {
    id
    __typename
    ...ContentMedia
  }
  ... on ContentStackedcardRecord {
    id
    __typename
    ...ContentStackedCard
  }
  ... on ContentTextRecord {
    id
    __typename
    ...ContentText
  }
  ... on ContentValueRecord {
    id
    __typename
    ...ContentValues
  }
  ... on TeaserBigRecord {
    id
    __typename
    ...TeaserBig
  }
  ... on ContentVideoRecord {
    id
    __typename
    ...ContentVideo
  }
}
    `;
export const PageMetaFragmentDoc = gql`
    fragment PageMeta on PageRecord {
  id
  slug
  title
  _seoMetaTags {
    attributes
    content
    tag
  }
}
    `;
export const SiteInfoFragmentDoc = gql`
    fragment SiteInfo on SiteInfoRecord {
  pageTitle
  address {
    value
  }
  telephone
  email
  linkLocation
  copyrightInformation
}
    `;
export const ContentSceneFragmentDoc = gql`
    fragment ContentScene on ContentSceneRecord {
  title
  id
  copy
  video {
    video {
      streamingUrl
      thumbnailUrl(format: png)
      muxPlaybackId
      title
      width
      height
      blurUpThumb
    }
    responsiveImage {
      src
    }
  }
  thumbnail {
    responsiveImage(imgixParams: {fit: crop, w: 500, auto: format}) {
      ...ResponsiveImage
    }
  }
}
    `;
export const NavigationTeaserFragmentDoc = gql`
    fragment NavigationTeaser on NavigationTeaserRecord {
  image {
    url
    alt
    mimeType
    responsiveImage {
      ...ResponsiveImage
    }
    video {
      streamingUrl
      muxPlaybackId
    }
  }
  link {
    ...Link
  }
}
    `;
export const GetAllFaqCategoriesDocument = gql`
    query GetAllFaqCategories($locale: SiteLocale) {
  allFaqCategories(locale: $locale) {
    title
    id
    content {
      ...ContentDownloadlist
    }
  }
}
    ${ContentDownloadlistFragmentDoc}
${DownloadItemFragmentDoc}
${ResponsiveImageFragmentDoc}`;
export const GetClinicExperienceDocument = gql`
    query GetClinicExperience($locale: SiteLocale) {
  clinicExperience(locale: $locale) {
    contentScenes {
      ...ContentScene
    }
  }
}
    ${ContentSceneFragmentDoc}
${ResponsiveImageFragmentDoc}`;
export const GetFooterNavigationDocument = gql`
    query GetFooterNavigation($locale: SiteLocale) {
  footerNavigation(locale: $locale) {
    navLinks {
      ...NavigationLink
    }
  }
}
    ${NavigationLinkFragmentDoc}
${PageLinkFragmentDoc}`;
export const GetJobBySlugDocument = gql`
    query GetJobBySlug($slug: String, $locale: SiteLocale) {
  jobPosting(locale: $locale, filter: {slug: {eq: $slug}}) {
    title
    content {
      ...JobPostingContent
    }
  }
}
    ${JobPostingContentFragmentDoc}
${ContentAccordionFragmentDoc}
${ContentTextFragmentDoc}
${ContentMediaFragmentDoc}
${ImageFragmentDoc}
${ResponsiveImageFragmentDoc}
${BackgroundVideoFragmentDoc}`;
export const GetMainNavigationDocument = gql`
    query GetMainNavigation($locale: SiteLocale) {
  mainNavigation(locale: $locale) {
    navigationTeaser {
      ...NavigationTeaser
    }
    navLinks {
      ...NavigationLink
    }
  }
}
    ${NavigationTeaserFragmentDoc}
${ResponsiveImageFragmentDoc}
${LinkFragmentDoc}
${PageLinkFragmentDoc}
${NavigationLinkFragmentDoc}`;
export const GetPageBySlugDocument = gql`
    query GetPageBySlug($slug: String, $locale: SiteLocale) {
  page(locale: $locale, filter: {slug: {eq: $slug}}) {
    ...PageMeta
    pageLayout
    headerModule {
      ...HeaderModulesPage
    }
    modules {
      ...Modules
    }
  }
}
    ${PageMetaFragmentDoc}
${HeaderModulesPageFragmentDoc}
${HeaderMediaFragmentDoc}
${ResponsiveImageFragmentDoc}
${HeaderContactFragmentDoc}
${ContactCardFragmentDoc}
${HeaderDefaultFragmentDoc}
${ModulesFragmentDoc}
${ContentAccordionFragmentDoc}
${ContentClinic3dFragmentDoc}
${ContentDownloadlistFragmentDoc}
${DownloadItemFragmentDoc}
${ContentFaqFragmentDoc}
${QuestionAndAnswerFragmentDoc}
${FaqCategoryFragmentDoc}
${ContentJobslistFragmentDoc}
${JobPostingFragmentDoc}
${JobPostingContentFragmentDoc}
${ContentTextFragmentDoc}
${ContentMediaFragmentDoc}
${ImageFragmentDoc}
${BackgroundVideoFragmentDoc}
${ContentStackedCardFragmentDoc}
${StackedCardItemFragmentDoc}
${LinkFragmentDoc}
${PageLinkFragmentDoc}
${ContentValuesFragmentDoc}
${ValueFragmentDoc}
${TeaserBigFragmentDoc}
${ContentVideoFragmentDoc}`;
export const GetSiteInfoDocument = gql`
    query GetSiteInfo($locale: SiteLocale) {
  siteInfo(locale: $locale) {
    ...SiteInfo
  }
}
    ${SiteInfoFragmentDoc}`;
export const GetTranslatedSlugsDocument = gql`
    query GetTranslatedSlugs($locale: SiteLocale) {
  allPages(locale: $locale) {
    slug
    title
    _allSlugLocales {
      locale
      value
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetAllFaqCategories(variables?: GetAllFaqCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetAllFaqCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllFaqCategoriesQuery>(GetAllFaqCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetAllFaqCategories', 'query', variables);
    },
    GetClinicExperience(variables?: GetClinicExperienceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetClinicExperienceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetClinicExperienceQuery>(GetClinicExperienceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetClinicExperience', 'query', variables);
    },
    GetFooterNavigation(variables?: GetFooterNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetFooterNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetFooterNavigationQuery>(GetFooterNavigationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetFooterNavigation', 'query', variables);
    },
    GetJobBySlug(variables?: GetJobBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetJobBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetJobBySlugQuery>(GetJobBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetJobBySlug', 'query', variables);
    },
    GetMainNavigation(variables?: GetMainNavigationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetMainNavigationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetMainNavigationQuery>(GetMainNavigationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetMainNavigation', 'query', variables);
    },
    GetPageBySlug(variables?: GetPageBySlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPageBySlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPageBySlugQuery>(GetPageBySlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetPageBySlug', 'query', variables);
    },
    GetSiteInfo(variables?: GetSiteInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetSiteInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSiteInfoQuery>(GetSiteInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetSiteInfo', 'query', variables);
    },
    GetTranslatedSlugs(variables?: GetTranslatedSlugsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetTranslatedSlugsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTranslatedSlugsQuery>(GetTranslatedSlugsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetTranslatedSlugs', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;